namespace Core {

    class UrlDiscount {

        code:string;

        constructor(private $http){
            if (!_.isEmpty(this.code)) {
                $http.get('?dlc='+this.code).then(() => {
                    TRPCONFIG.DiscountCode = this.code;
                });
            }
        }
    }


    angular.module('core')
    .directive('urlDiscount', (): ng.IDirective => {
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                code: '@'
            },
            controller: UrlDiscount,
            controllerAs: 'urld'
        };
    });
}
